import { ManualInjector } from '../../../../../manual-injector';
import EquipmentInfoService from '../../../../../../components/base/infoServices/EquipmentInfoService';
import _ from 'lodash';
export default class EquipmentType {
    static async load({ customKey, customDescription, filterOnProperty, hideOn }) {
        const equipmentInfoService = ManualInjector.injector.get(EquipmentInfoService);
        const eqTypes = await equipmentInfoService.getAllTypes();
        const eqTypesSelection = _.transform(eqTypes, (memo, eqType) => {
            memo.push({
                label: _.upperFirst(eqType),
                value: eqType
            });
        });
        const componentSchema = {
            label: 'Equipment Type',
            description: customDescription || 'Only filters events by equipment type. Does not save.',
            key: customKey || 'equipmentTypeSelect',
            type: 'select',
            dataSrc: 'values',
            valueProperty: 'value',
            refreshOn: filterOnProperty,
            clearOnRefresh: true,
            clearOnHidden: true,
            multi: false,
            data: {
                values: eqTypesSelection
            },
        };
        if (hideOn) {
            componentSchema.hidden = true; // hide by default to (hopefully) reduce jitters
            componentSchema.customConditional = ({ data }) => !data[hideOn];
        }
        return componentSchema;
    }
}
